import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type FreeProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Free = ({ size = 24, width, height, alt = '', style, ...props }: FreeProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'rect',
        {
          width: '24',
          height: '24',
          rx: '4',
          fill: 'url(#paint0_linear_722_9556)',
        },
      ),
      h(
        'rect',
        {
          x: '0.25',
          y: '0.25',
          width: '23.5',
          height: '23.5',
          rx: '3.75',
          stroke: 'url(#paint1_linear_722_9556)',
          "stroke-opacity": '0.3',
          "stroke-width": '0.5',
          "stroke-linecap": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M7.83233 11.1376L7.58894 12.2914H4.67278L4.08233 15.0769H2.70312L4.10937 8.44229H8.81941L8.57151 9.60966H5.24069L4.91617 11.1376H7.83233ZM12.0421 10.0469C12.0571 10.0499 12.0916 10.0529 12.1457 10.0559L11.8663 11.372C11.7882 11.363 11.7175 11.357 11.6544 11.3539C11.5913 11.3509 11.5403 11.3494 11.5012 11.3494C10.9844 11.3494 10.6013 11.5177 10.3519 11.8542C10.2136 12.0436 10.1025 12.335 10.0183 12.7286L9.52254 15.0769H8.22897L9.27013 10.164H10.4961L10.3158 11.0204C10.5832 10.6929 10.8026 10.469 10.9739 10.3488C11.2593 10.1475 11.5944 10.0469 11.979 10.0469C12.003 10.0469 12.024 10.0469 12.0421 10.0469ZM14.7284 13.9726C14.8335 13.8915 14.9372 13.7788 15.0394 13.6346H16.351C16.2548 13.9261 16.04 14.222 15.7064 14.5225C15.1836 15.0003 14.5436 15.2392 13.7864 15.2392C13.1614 15.2392 12.652 15.0378 12.2584 14.6352C11.8678 14.2326 11.7686 13.5775 11.9609 12.6701C12.1412 11.8197 12.4943 11.1676 13.0201 10.7139C13.549 10.2602 14.1575 10.0333 14.8456 10.0333C15.2542 10.0333 15.6058 10.11 15.9002 10.2632C16.1977 10.4164 16.4171 10.6583 16.5583 10.9889C16.6905 11.2803 16.7431 11.6184 16.716 12.003C16.704 12.2283 16.6499 12.5529 16.5538 12.9765H13.1914C13.1043 13.4693 13.1854 13.8149 13.4348 14.0132C13.585 14.1364 13.7849 14.198 14.0343 14.198C14.2987 14.198 14.53 14.1229 14.7284 13.9726ZM14.6202 11.0925C14.3227 11.0925 14.0718 11.1857 13.8675 11.372C13.6662 11.5583 13.5114 11.8107 13.4032 12.1292H15.3999C15.451 11.7896 15.4014 11.5327 15.2512 11.3585C15.104 11.1812 14.8936 11.0925 14.6202 11.0925ZM19.8666 13.9726C19.9718 13.8915 20.0754 13.7788 20.1776 13.6346H21.4892C21.393 13.9261 21.1782 14.222 20.8447 14.5225C20.3218 15.0003 19.6818 15.2392 18.9246 15.2392C18.2996 15.2392 17.7903 15.0378 17.3966 14.6352C17.006 14.2326 16.9069 13.5775 17.0992 12.6701C17.2794 11.8197 17.6325 11.1676 18.1584 10.7139C18.6872 10.2602 19.2957 10.0333 19.9838 10.0333C20.3924 10.0333 20.744 10.11 21.0385 10.2632C21.3359 10.4164 21.5553 10.6583 21.6965 10.9889C21.8287 11.2803 21.8813 11.6184 21.8543 12.003C21.8422 12.2283 21.7882 12.5529 21.692 12.9765H18.3296C18.2425 13.4693 18.3236 13.8149 18.573 14.0132C18.7233 14.1364 18.9231 14.198 19.1725 14.198C19.4369 14.198 19.6683 14.1229 19.8666 13.9726ZM19.7584 11.0925C19.4609 11.0925 19.21 11.1857 19.0057 11.372C18.8044 11.5583 18.6496 11.8107 18.5415 12.1292H20.5382C20.5892 11.7896 20.5397 11.5327 20.3894 11.3585C20.2422 11.1812 20.0319 11.0925 19.7584 11.0925Z',
          fill: '#008069',
        },
      ),
      h(
        'defs',
        {
        },
        [
          h(
            'linearGradient',
            {
              id: 'paint0_linear_722_9556',
              x1: '-18.2374',
              y1: '-57.7414',
              x2: '66.435',
              y2: '-60.9184',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#B0F7E0',
                  "stop-opacity": '0.3',
                },
              ),
            ],
          ),
          h(
            'linearGradient',
            {
              id: 'paint1_linear_722_9556',
              x1: '-0.503001',
              y1: '6.71775',
              x2: '24.8358',
              y2: '7.15595',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '0.475962',
                  "stop-color": '#89F9C1',
                },
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Free;
